import {
  DEACTIVATE_USER,
} from './constants'

export function deactivateUser (password) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: DEACTIVATE_USER,
      payload: mapmy.deactivateUser(password),
    })
  }
}
